import { useState, useEffect } from "react";

import { Switch, TextField, Button, Box, List, ListItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export default function SlideCurrentFaults({
  initialFaults,
  faultsRef,
  removedFaultsRef,
  removedCurrentFaultsRef,
  user,
  valueRef,
}) {
  const [faults] = useState(initialFaults);
  const [addedInputs, setAddedInputs] = useState([]);
  const [repairNotes, setRepairNotes] = useState({});
  const [switchStates, setSwitchStates] = useState({});

  const RedSwitch = styled(Switch)({
    "& .Mui-checked": {
      color: "#d32f2f !important",
    },
    "& .Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#d32f2f !important",
    },
  });

  useEffect(() => {
    const initialStates = {};
    if (faults) {
      faults.forEach((fault) => {
        initialStates[fault.fault_id] = true;
      });
      setSwitchStates(initialStates);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggle = (index) => {
    const fault = faults[index];
    const isActive = switchStates[fault.fault_id];
    setSwitchStates((prev) => ({ ...prev, [fault.fault_id]: !isActive }));

    const date = new Date();

    const formattedDate = date.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    if (isActive) {
      if (!removedCurrentFaultsRef.current.includes(fault.fault_id)) {
        const a = faults.find((item) => item.fault_id === fault.fault_id);

        removedCurrentFaultsRef.current.push({
          fault_id: a.fault_id,
          system: a.system,
          fault: a.fault,
          reported_at: a.reported_at,
          reported_by: a.name,
          resolved_at: formattedDate,
          resolved_by: user.name,
          fix_notes: "",
          user_id: user.id,
        });
      }
    } else {
      removedCurrentFaultsRef.current = removedCurrentFaultsRef.current.filter(
        (id) => id !== fault.fault_id
      );
    }
  };

  const handleAddFault = () => {
    const newFaultId = Date.now();
    setAddedInputs((prev) => [...prev, { fault_id: newFaultId, system: "", fault: "" }]);
    faultsRef.current.push({ fault_id: newFaultId, system: "", fault: "" });
  };

  const handleRemoveFault = (faultId) => {
    setAddedInputs((prev) => prev.filter((fault) => fault.fault_id !== faultId));

    faultsRef.current = faultsRef.current.filter((fault) => fault.fault_id !== faultId);

    removedFaultsRef.current.push(faultId);
  };

  const handleInputChange = (id, field, value) => {
    setAddedInputs((prev) =>
      prev.map((input) => (input.fault_id === id ? { ...input, [field]: value } : input))
    );
    const index = faultsRef.current.findIndex((fault) => fault.fault_id === id);

    if (index !== -1) {
      faultsRef.current[index][field] = value;
    }
  };

  const handleRepairNoteChange = (faultId, value) => {
    setRepairNotes((prev) => {
      const updatedNotes = { ...prev, [faultId]: value };
      valueRef.current = updatedNotes;
      return updatedNotes;
    });
  };

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "auto" }} autoComplete="off">
      <List>
        {faults?.map((fault, index) => (
          <ListItem
            key={fault.fault_id}
            sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box sx={{ mb: 1 }}>
                <Typography sx={{ color: "#fff", fontSize: "13px", fontFamily: "Montserrat" }}>
                  {fault.reported_at}
                </Typography>
                <Typography sx={{ color: "#fff", fontSize: "13px", fontFamily: "Montserrat" }}>
                  {fault.system}
                </Typography>
                <Typography sx={{ color: "#fff", fontSize: "13px", fontFamily: "Montserrat" }}>
                  {fault.fault}
                </Typography>
                <Typography sx={{ color: "#fff", fontSize: "13px", fontFamily: "Montserrat" }}>
                  {fault.name}
                </Typography>
              </Box>
              <RedSwitch
                checked={!!switchStates[fault.fault_id]}
                onChange={() => handleToggle(index)}
              />
            </Box>
            {!switchStates[fault.fault_id] && (
              <TextField
                key={fault.fault_id}
                label="Произведенные работы"
                value={repairNotes[fault.fault_id] || ""}
                onChange={(e) => handleRepairNoteChange(fault.fault_id, e.target.value)}
                fullWidth
                required
                multiline
                sx={{
                  mt: 1,
                  borderRadius: "5px",
                  color: "#fff",
                  "& .MuiInputLabel-root": {
                    color: "#fff",
                  },
                }}
              />
            )}
          </ListItem>
        ))}

        {addedInputs.map((input) => (
          <ListItem
            key={input.fault_id}
            sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}
          >
            <TextField
              label="Система"
              variant="outlined"
              onChange={(e) => handleInputChange(input.fault_id, "system", e.target.value)}
              fullWidth
              sx={{ mb: 1, color: "#fff" }}
            />
            <TextField
              label="Неисправность"
              variant="outlined"
              onChange={(e) => handleInputChange(input.fault_id, "fault", e.target.value)}
              fullWidth
              sx={{ mb: 1, color: "#fff" }}
            />
            <Button
              onClick={() => handleRemoveFault(input.fault_id)}
              variant="contained"
              color="error"
              sx={{ mt: 1 }}
            >
              Удалить
            </Button>
          </ListItem>
        ))}
      </List>
      <Button
        onClick={handleAddFault}
        variant="contained"
        color="primary"
        sx={{ mt: 2, mb: 9, width: "100%" }}
      >
        Добавить неисправность
      </Button>
    </Box>
  );
}
